import { NgModule } from '@angular/core';
import { AddressPipe } from './address.pipe';
import { ArticleStatusPipe } from './article-status.pipe';
import { BadgeStatusDescColorPipe } from './badge-status-desc-color.pipe';
import { ContractPhaseColorPipe } from './contract-phase-color.pipe';
import { DateFormulaToDatePipe } from './date-formula-to-date.pipe';
import { DatePipe } from './date.pipe';
import { FilterPipe } from './filter.pipe';
import { FormSelectionMethodPipe } from './form-selection-method.pipe';
import { ListPipe } from './list.pipe';
import { NumberPipe } from './number.pipe';
import { PaginatePipe } from './paginate.pipe';
import { PhonePipe } from './phone.pipe';
import { RoleTypePipe } from './roletype.pipe';
import { ShowLastFourCharactersPipe } from './show-last-four-characters.pipe';

@NgModule({
    imports: [],
    declarations: [
        PhonePipe,
        AddressPipe,
        NumberPipe,
        DatePipe,
        FilterPipe,
        PaginatePipe,
        ListPipe,
        ContractPhaseColorPipe,
        RoleTypePipe,
        ArticleStatusPipe,
        FormSelectionMethodPipe,
        DateFormulaToDatePipe,
        ShowLastFourCharactersPipe,
        BadgeStatusDescColorPipe
    ],
    exports: [
        PhonePipe,
        AddressPipe,
        NumberPipe,
        DatePipe,
        FilterPipe,
        PaginatePipe,
        ListPipe,
        ContractPhaseColorPipe,
        RoleTypePipe,
        ArticleStatusPipe,
        FormSelectionMethodPipe,
        DateFormulaToDatePipe,
        ShowLastFourCharactersPipe,
        BadgeStatusDescColorPipe
    ]
})
export class PipeModule { }
